import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationService } from 'src/app/Services/authorization/authorization.service';
import { AppGlobals } from 'src/app/Shared/app.globals';
import { environment } from 'src/environments/environment';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [AppGlobals],
})
export class LoginComponent implements OnInit {
  private auth = inject(AuthorizationService);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private constants = inject(AppGlobals);

  xerxesState = localStorage.getItem('xerxesState');

  ngOnInit() {
    const ssoPartner = localStorage.getItem('ssoPartner');
    localStorage.clear();
    this.route.queryParams.subscribe({
      next: (queryParam) => {
        this.auth.userCode = queryParam.code;
        localStorage.setItem('code', queryParam.code);
        if (this.auth.userCode) {
          this.auth.getUserValues().subscribe({
            next: (res) => {
              this.auth.profileName = res.displayName;
              this.auth.partnerName = res.partner;
              this.auth.userEmail = res.email;
              this.auth.rawToken = res.rawToken;
              this.auth.tokenExpirationTime = res.expirationTime;

              const roles: string[] = res.userRoles || [];
              const isInternal = roles
                .map((r) => r.toLowerCase())
                .includes(this.constants.mvpdTeamRole.toLowerCase());
              localStorage.setItem(
                'userType',
                isInternal ? 'internal' : 'external',
              );

              if (!localStorage.getItem('rawToken')) {
                localStorage.setItem('rawToken', res.userToken);
                this.auth.isLoggedIn = true;
                localStorage.setItem('isLoggedIn', 'true');
              } else {
                this.auth.isLoggedIn = false;
              }
              if (!localStorage.getItem('partnerName')) {
                localStorage.setItem('partnerName', res.partner);
              }
              if (!localStorage.getItem('tokenExpirationTime')) {
                localStorage.setItem('tokenExpirationTime', res.expirationTime);
              }
              if (!localStorage.getItem('userEmail')) {
                localStorage.setItem('userEmail', res.email);
              }
              if (!localStorage.getItem('user')) {
                localStorage.setItem('user', res.displayName);
              }

              const userRoles = res.userRoles;
              this.auth.userRoleList = res.userRoles;
              localStorage.setItem('roleList', JSON.stringify(res.userRoles));
              userRoles.forEach((role) => {
                switch (role.toUpperCase()) {
                  case this.constants.adminRole: {
                    localStorage.setItem('isAdmin', 'true');
                    break;
                  }
                  case this.constants.superAdminRole: {
                    localStorage.setItem('isSuperAdmin', 'true');
                    break;
                  }
                  case this.constants.dashboardDescriptionRole: {
                    localStorage.setItem('CanEditDashboard', 'true');
                    break;
                  }
                  case this.constants.mvpdTeamRole: {
                    localStorage.setItem('mvpdRole', 'true');
                    break;
                  }
                  case this.constants.comcastGeneralRole.toUpperCase(): {
                    localStorage.setItem('hasGeneralRole', 'true');
                    break;
                  }
                  case this.constants.comcastGlobalRole.toUpperCase(): {
                    localStorage.setItem('hasGlobalRole', 'true');
                    break;
                  }
                }
              });

              if (queryParam.state) {
                this.router.navigateByUrl(atob(queryParam.state));
              } else {
                this.router.navigate(['/home']);
              }
            },
            error: (err) => {
              if (err.status === 403) {
                alert(err.error);
              }
              this.router.navigate(['/splash']);
            },
          });
        } else {
          switch (ssoPartner) {
            case 'sky-group': {
              const ssoURL = environment.EU_xerxesUrl;
              const appName = environment.EU_xerxesApp;
              this.signOnUser(ssoURL, appName);
              break;
            }

            case 'foxtel': {
              const ssoURL = environment.APAC_xerxesUrl;
              const appName = environment.APAC_xerxesApp;
              this.signOnUser(ssoURL, appName);
              break;
            }

            default: {
              const ssoURL = environment.NA_xerxesUrl;
              const appName = environment.NA_xerxesApp;
              this.signOnUser(ssoURL, appName);
              break;
            }
          }
        }
      },
      error: (err) => {},
    });
  }
  signOnUser(xerxesUrl: any, xerxesApp: any) {
    if (this.xerxesState) {
      window.location.href =
        xerxesUrl +
        'oauth/authorize?client_id=' +
        xerxesApp +
        '&response_type=code&redirect_uri=' +
        location.protocol +
        '//' +
        location.hostname +
        (location.port ? ':' + location.port : '') +
        '/login&state=' +
        btoa(this.xerxesState);
    } else {
      window.location.href =
        xerxesUrl +
        'oauth/authorize?client_id=' +
        xerxesApp +
        '&response_type=code&redirect_uri=' +
        location.protocol +
        '//' +
        location.hostname +
        (location.port ? ':' + location.port : '') +
        '/login';
    }
  }
}
